import { Controller } from "@hotwired/stimulus"
export default class extends Controller {
  static targets = ["item"]
  connect() {
    this.io = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add("animate-in")
          this.io.unobserve(e.target)
        }
      })
    }, { threshold: 0.1, rootMargin: "0px 0px -40px 0px" })
    this.itemTargets.forEach(el => this.io.observe(el))
  }
  disconnect() { this.io?.disconnect() }
}
